import { createApp } from 'vue'; // Importação correta para Vue 3
import App from './App.vue';
import router from './router';
import store from './store';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import VueTheMask from 'vue-the-mask';
import Icon from '@/components/icons/Icon.vue'
import { setupVersionChecker } from './version-checker'; // Importar o verificador de versão
import TelefoneInternacional from '@/components/TelefoneInternacional.vue';
import '../node_modules/vue-tel-input/dist/vue-tel-input.css';
import InputNome from '@/components/form/InputNome.vue'

require('@/store/subscriber');

// Cria a aplicação Vue e passa a instância do App.vue
const app = createApp(App);

/* eslint-disable vue/multi-word-component-names */
app.component('Icon', Icon);

app.component('InputNome', InputNome)

app.component('telefone-internacional', TelefoneInternacional);


// Registra o Vue Router com a aplicação Vue
app.use(router);

// Registra o Vuex store com a aplicação Vue
app.use(store);

app.use(VueSweetalert2);

app.use(VueTheMask);

// Monta a aplicação Vue no elemento com id #app no seu index.html
app.mount('#app');

// Inicializar o verificador de versão após a montagem do aplicativo
setupVersionChecker(5); // Verificar a cada 5 minutos

// Se você precisar despachar uma ação ao iniciar, faça isso após montar a aplicação
store.dispatch('auth/attempt', localStorage.getItem('token')).then(() => {
    // Qualquer lógica adicional que precisa ser executada após o despacho da ação
});

// store.dispatch('auth/attemptUser', localStorage.getItem('user')).then(() => {
//   // Qualquer lógica adicional que precisa ser executada após o despacho da ação
// });